jQuery(document).ready(function () {
  jQuery(".accordion-content").on("show.bs.collapse", function () {
    // var id = jQuery(this).attr("data-service-id");

    // Hide all asides
    //jQuery(".card-aside").removeClass('inplace');

    // Show this aside
    //jQuery("#card-aside-" + id).addClass('inplace');

    var element_id = jQuery(this).attr("id");
    console.log(element_id);
    // This accordion
    var this_accordion_id = jQuery(this).attr("data-parent"); // has hash

    // Fidn the parent card and add active to it.
    jQuery(this_accordion_id + " .card").removeClass("active");
    jQuery(this_accordion_id + " .card").removeClass("inplace");
    jQuery("#" + element_id)
      .parent()
      .parent()
      .addClass("active");

    // Add inplace after .2 seconds
    setTimeout(function () {
      jQuery("#" + element_id)
        .parent()
        .parent()
        .addClass("inplace");
    }, 220);
  });

  // Add data-featherlight="image" to the first link in each grid item.

  jQuery(".lightbox-grid").each(function (index, element) {
    jQuery(element)
      .find(".grid-item")
      .each(function (index2, element2) {
        // Do something with each inner element
        jQuery(element2).find("a").first().attr("data-featherlight", "image");
      });
  });
});






(function () {
  function wrapWords(el) {
    var text = (el.textContent || el.innerText || "")
      .replace(/\s+/g, " ")
      .trim();

    if (!text) return [];

    var words = text.split(" ");
    var html = "";

    for (var i = 0; i < words.length; i++) {
      html +=
        '<span class="word">' +
        words[i] +
        "</span>" +
        (i < words.length - 1 ? " " : "");
    }

    el.innerHTML = html;

    var nodeList = el.querySelectorAll(".word");
    var spans = [];

    for (var j = 0; j < nodeList.length; j++) {
      spans.push(nodeList[j]);
      nodeList[j].style.display = "inline-block";
    }

    return spans;
  }

  function runHeroWordAnim() {
    var startDelay = 0.35;

    var hero = document.querySelector(".hero-animate");
    if (!hero) return;

    var realH1 = hero.querySelector("h1");
    var headline = hero.querySelector(".headline");
    if (!headline) return;

    var introText = hero.querySelector("p");
    var buttons = hero.querySelectorAll("a.butt");

    // Important: avoid parent/child conflict when h1.headline is the same element.
    var hasSeparateH1 = realH1 && realH1 !== headline;

    var headlineSpans = wrapWords(headline);
    if (!headlineSpans.length) return;

    var buttonArray = [];

    for (var i = 0; i < buttons.length; i++) {
      buttonArray.push(buttons[i]);
    }

    if (typeof TweenMax === "undefined" || typeof TimelineMax === "undefined") {
      setTimeout(function () {
        if (hasSeparateH1) {
          realH1.style.opacity = "1";
          realH1.style.visibility = "visible";
        }

        headline.style.opacity = "1";
        headline.style.visibility = "visible";

        headlineSpans.forEach(function (span) {
          span.style.opacity = "1";
          span.style.visibility = "visible";
        });

        if (introText) {
          introText.style.opacity = "1";
          introText.style.visibility = "visible";
        }

        buttonArray.forEach(function (button) {
          button.style.opacity = "1";
          button.style.visibility = "visible";
        });
      }, startDelay * 1000);

      return;
    }

    TweenMax.killTweensOf(
      (hasSeparateH1 ? [realH1] : [])
        .concat([headline])
        .concat(headlineSpans)
        .concat(introText ? [introText] : [])
        .concat(buttonArray)
    );

    if (hasSeparateH1) {
      TweenMax.set(realH1, { autoAlpha: 0, y: 10 });
    }

    TweenMax.set(headline, { autoAlpha: 1 });
    TweenMax.set(headlineSpans, { autoAlpha: 0, y: 16 });

    if (introText) {
      TweenMax.set(introText, { autoAlpha: 0, y: 16 });
    }

    if (buttonArray.length) {
      TweenMax.set(buttonArray, { autoAlpha: 0, y: 16 });
    }

    var tl = new TimelineMax({
      delay: startDelay
    });

    if (hasSeparateH1) {
      tl.to(realH1, 0.5, {
        autoAlpha: 1,
        y: 0,
        ease: Power3.easeOut
      });
    }

    tl.staggerTo(
      headlineSpans,
      0.7,
      {
        autoAlpha: 1,
        y: 0,
        ease: Power3.easeOut
      },
      0.06,
      hasSeparateH1 ? "-=0.1" : 0
    );

    if (introText) {
      tl.to(
        introText,
        0.6,
        {
          autoAlpha: 1,
          y: 0,
          ease: Power3.easeOut
        },
        "-=0.25"
      );
    }

    if (buttonArray.length) {
      tl.staggerTo(
        buttonArray,
        0.6,
        {
          autoAlpha: 1,
          y: 0,
          ease: Power3.easeOut
        },
        0.08,
        "-=0.35"
      );
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(runHeroWordAnim);
    });
  });
})();







// Scroll pin + crossfade feature
document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn("GSAP/ScrollTrigger not loaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var media = document.querySelector(".scroll-block1 .col-first .inner");
  var section2 = document.querySelector(".scroll-block2");
  var header = document.querySelector(".headroom");

  if (!media || !section2) return;

  var img1 = media.querySelector("img.img1");
  var img2 = media.querySelector("img.img2");
  if (!img1 || !img2) return;

  // Ensure initial visibility states
  gsap.set(img1, { autoAlpha: 1 });
  gsap.set(img2, { autoAlpha: 0 });

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }


  function headerH() {
    return 80;
    //return 116;
    //return header ? header.offsetHeight : 0;
  }

  function docTop(el) {
    var r = el.getBoundingClientRect();
    return r.top + scrollY();
  }

  function calcDistance() {
    var s2Anchor = section2.querySelector(".container-fluid") || section2;

    var mediaH = media.getBoundingClientRect().height;
    var mediaTop = docTop(media);

    var s2Top = docTop(s2Anchor);
    var s2H = section2.getBoundingClientRect().height;

    var targetTop = s2Top + (s2H - mediaH) / 2;
    var dist = targetTop - mediaTop;

    return dist > 0 ? dist : 0;
  }

  // Pin behavior (unchanged)
  ScrollTrigger.create({
    trigger: media,
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    pin: media,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
  });

  // Crossfade scrub over same scroll range
  ScrollTrigger.create({
    trigger: media,
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    scrub: true,
    invalidateOnRefresh: true,
    onUpdate: function (self) {
      // crossfade centered around halfway
      var center = 0.5;
      var halfWindow = 0.12; // fade spans ~0.38 -> ~0.62
      var t = (self.progress - (center - halfWindow)) / (2 * halfWindow);

      if (t < 0) t = 0;
      if (t > 1) t = 1;

      gsap.set(img1, { autoAlpha: 1 - t });
      gsap.set(img2, { autoAlpha: t });
    },
  });

  function refreshAll() {
    ScrollTrigger.refresh();
  }

  // Refresh after images load (important for correct heights)
  if (!img1.complete) img1.addEventListener("load", refreshAll);
  if (!img2.complete) img2.addEventListener("load", refreshAll);

  window.addEventListener("resize", refreshAll);
  ScrollTrigger.refresh();
});




// Animate projects header
document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger || !window.imagesLoaded) {
    console.warn("Missing gsap / ScrollTrigger / imagesLoaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  function initInnerReveal(inner) {
    var img = inner.querySelector("img");
    if (!img) return;

    gsap.set(inner, { opacity: 1, clipPath: "inset(0% 0% 100% 0%)" });
    gsap.set(img, { opacity: 0, scale: 1.06 });

    // Optional: reveal nearby text in the same row
    var textTargets = [];
    var row = inner.closest(".row") || inner.parentNode;
    if (row) {
      var els = row.querySelectorAll("h1,h2,h3,p,li,.wp-block-button");
      for (var i = 0; i < els.length; i++) {
        if (els[i].closest(".inner") === inner) continue;
        textTargets.push(els[i]);
      }
    }

    var tl = gsap.timeline({
      paused: true,
      defaults: { ease: "power3.out" },
    });

    tl.to(inner, { clipPath: "inset(0% 0% 0% 0%)", duration: 0.9 }, 0);
    tl.to(img, { opacity: 1, scale: 1, duration: 1.0 }, 0.05);

    if (textTargets.length) {
      tl.fromTo(
        textTargets,
        { autoAlpha: 0, y: 18 },
        { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.06 },
        0.25
      );
    }

    // Wait for image to load before allowing reveal
    imagesLoaded(img, function () {
      ScrollTrigger.create({
        trigger: inner,
        start: "top 80%",
        once: true,
        onEnter: function () {
          tl.play(0);
        },
      });
    });
  }

  function boot() {
    var inners = document.querySelectorAll(".projects-header .inner");
    for (var i = 0; i < inners.length; i++) {
      initInnerReveal(inners[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
});


// Animate projects list page
document.addEventListener("DOMContentLoaded", function () {

  if (!window.gsap) {
    console.warn("GSAP not found");
    return;
  }

  // Your template row has BOTH classes on the same node
  var itemSelector = ".facetwp-template.projects-row > [class*='col-']";

  function animateProjectsGrid() {
    var items = document.querySelectorAll(itemSelector);
    if (!items || !items.length) return;

    gsap.killTweensOf(items);
    gsap.set(items, { autoAlpha: 0, y: 18 });

    if (window.imagesLoaded) {
      imagesLoaded(items, function () {
        gsap.to(items, {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          ease: "power3.out",
          stagger: { each: 0.07, from: "start" },
        });
      });
    } else {
      gsap.to(items, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        stagger: { each: 0.07, from: "start" },
      });
    }
  }

  // Initial
  jQuery(function () {
    animateProjectsGrid();
  });

  // After FacetWP refresh
  jQuery(document).on("facetwp-loaded", function () {
    // next tick after DOM swap
    setTimeout(function () {
      animateProjectsGrid();
    }, 0);
  });
});


// Put this in a global JS file or inline (footer is fine)
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("facetwp-loaded", function () {
    // Close all fSelect dropdowns
    if (typeof fUtil !== "undefined") {
      fUtil(".facetwp-type-fselect .facetwp-dropdown").each(function () {
        // FacetWP attaches the fSelect instance to the dropdown node
        if (this.fselect && typeof this.fselect.close === "function") {
          this.fselect.close();
        }
      });
    } else {
      // Fallback if fUtil isn't available for some reason
      var els = document.querySelectorAll(
        ".facetwp-type-fselect .facetwp-dropdown"
      );
      for (var i = 0; i < els.length; i++) {
        if (els[i].fselect && typeof els[i].fselect.close === "function") {
          els[i].fselect.close();
        }
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  // Target each slider instance
  document
    .querySelectorAll(".projects-client-slider .swiper")
    .forEach(function (swiperEl) {
      var slides = swiperEl.querySelectorAll(".swiper-slide");
      if (!slides.length) return;

      // Set initial state (in case CSS didn't load yet)
      gsap.set(slides, { autoAlpha: 0, y: 16 });

      ScrollTrigger.create({
        trigger: swiperEl,
        start: "top 80%",
        once: true,
        onEnter: function () {
          gsap.to(slides, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            stagger: 0.08,
            clearProps: "transform",
          });
        },
      });
    });
});

// Make tabbed content have the same height.
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".tabbed-content.tabs-eq-height .bs-tabs.accordion")
    .forEach(function (acc) {
      var panes = acc.querySelectorAll(".card .collapse"); // the collapsible wrappers
      if (!panes.length) return;

      var max = 0;

      panes.forEach(function (pane) {
        var body = pane.querySelector(".card-body");
        if (!body) return;

        // Save original inline styles + show state
        var wasShown = pane.classList.contains("show");
        var prevStyle = pane.getAttribute("style");

        // Make it measurable without flashing
        pane.classList.add("show");
        pane.style.display = "block";
        pane.style.height = "auto";
        pane.style.visibility = "hidden";
        pane.style.position = "absolute";
        pane.style.pointerEvents = "none";
        pane.style.left = "-99999px";
        pane.style.top = "0";

        // Measure natural content height
        var h = body.scrollHeight;
        if (h > max) max = h;

        // Restore state
        if (!wasShown) pane.classList.remove("show");
        if (prevStyle !== null) {
          pane.setAttribute("style", prevStyle);
        } else {
          pane.removeAttribute("style");
        }
      });

      // Apply min-height to all bodies
      acc.querySelectorAll(".card .card-body").forEach(function (b) {
        b.style.minHeight = max + "px";
      });
    });
});



// Swiper progress bullet feature.
function restartActiveBulletAnimation(swiper) {
  var bullets = swiper.el.querySelectorAll(".swiper-pagination-bullet");
  if (!bullets.length) return;

  // Remove animation by toggling a class is messy; easiest is reflow trick:
  bullets.forEach(function (b) {
    // remove animation by forcing it to reset
    b.classList.remove("is-animating");
  });

  var active = swiper.el.querySelector(".swiper-pagination-bullet-active");
  if (!active) return;

  // Force reflow then re-add class to restart animation
  // (works even if the same bullet becomes active again)
  void active.offsetWidth;
  active.classList.add("is-animating");
}



// Smooth scroll-to
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header.header");
  const hashLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

  if (!header) return;

  hashLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = this.getAttribute("href");
      var target = document.querySelector(id);

      console.log(headroom);

      if (!target) return;

      e.preventDefault();

      headroom.pin();
      //headroom.freeze();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      var timeout;

      var handleScroll = function () {
        clearTimeout(timeout);

        timeout = setTimeout(function () {
          window.removeEventListener("scroll", handleScroll);
          //headroom.unfreeze();
          headroom.unpin();
        }, 150);
      };

      window.addEventListener("scroll", handleScroll);
    });
  });
});




// Careers page rotator
document.addEventListener("DOMContentLoaded", function () {
  var el = document.querySelector(".word-rotator .rotate-word");
  if (!el) return;

  var words = ["Grow", "Succeed", "Have Fun", "Thrive"];
  var i = 0;

  // If the initial word matches one of the list items, start after it
  var startIndex = words.indexOf(el.textContent.trim());
  if (startIndex >= 0) i = startIndex;

  function nextWord() {
    i = (i + 1) % words.length;

    el.classList.add("is-changing");

    setTimeout(function () {
      el.textContent = words[i];
      el.classList.remove("is-changing");
    }, 250); // match CSS transition
  }

  setInterval(nextWord, 1500);
});





// Leadership grid
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.team-grid');
  if (!grid) return;

  var msnry = null;

  function initMasonry() {
    if (msnry) return;

    msnry = new Masonry(grid, {
      itemSelector: '.employee',
      percentPosition: true,
      horizontalOrder: true,
      transitionDuration: '0.25s'
    });

    // Store instance on the grid for easier access/debugging
    grid.msnry = msnry;

    relayoutMasonry();
  }

  function relayoutMasonry() {
    if (!msnry) return;

    // Immediate layout
    msnry.layout();

    // Small delayed pass for animations/content changes
    setTimeout(function () {
      msnry.layout();
    }, 30);

    // Second delayed pass for images/fonts/lazyload/cache weirdness
    setTimeout(function () {
      msnry.layout();
    }, 280);

    // Extra safety pass for WP Rocket/lazy-loaded content
    setTimeout(function () {
      msnry.layout();
    }, 600);
  }

  function initAfterImages() {
    if (typeof imagesLoaded !== 'undefined') {
      imagesLoaded(grid, function () {
        initMasonry();
        relayoutMasonry();
      });
    } else {
      initMasonry();
    }
  }

  // Start Masonry after images inside the grid are ready
  initAfterImages();

  // Re-layout once the full page is loaded
  window.addEventListener('load', function () {
    relayoutMasonry();
  });

  // Re-layout when WP Rocket/lazysizes-style lazyloaded images finish
  document.addEventListener('lazyloaded', function (e) {
    if (grid.contains(e.target)) {
      relayoutMasonry();
    }
  });

  // Re-layout when native lazy-loaded images inside the grid finish loading
  grid.querySelectorAll('img').forEach(function (img) {
    if (!img.complete) {
      img.addEventListener('load', function () {
        relayoutMasonry();
      });
    }
  });

  grid.addEventListener('click', function (e) {
    var toggle = e.target.closest('.employee-toggle');
    if (!toggle) return;

    e.preventDefault();

    var employee = toggle.closest('.employee');
    if (!employee) return;

    var bio = employee.querySelector('.employee-bio');
    var isOpen = employee.classList.contains('is-open');

    grid.querySelectorAll('.employee.is-open').forEach(function (item) {
      if (item !== employee) {
        item.classList.remove('is-open');

        var otherBio = item.querySelector('.employee-bio');
        var otherToggle = item.querySelector('.employee-toggle');

        if (otherBio) {
          otherBio.hidden = true;
        }

        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    if (isOpen) {
      employee.classList.remove('is-open');

      if (bio) {
        bio.hidden = true;
      }

      toggle.setAttribute('aria-expanded', 'false');
    } else {
      employee.classList.add('is-open');

      if (bio) {
        bio.hidden = false;
      }

      toggle.setAttribute('aria-expanded', 'true');
    }

    relayoutMasonry();
  });

  window.addEventListener('resize', function () {
    relayoutMasonry();
  });
});



// Projects grid
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.projects-grid');
  if (!grid) return;

  var projectsMasonry = null;

  function initProjectsMasonry() {
    if (!projectsMasonry) {
      projectsMasonry = new Masonry(grid, {
        itemSelector: '.project-card',
        columnWidth: '.grid-sizer',
        percentPosition: true,
        horizontalOrder: true,
        transitionDuration: '0.25s'
      });
    } else {
      projectsMasonry.reloadItems();
      projectsMasonry.layout();
    }
  }

  function layoutProjectsMasonry() {
    if (!projectsMasonry) return;

    projectsMasonry.reloadItems();

    setTimeout(function () {
      projectsMasonry.layout();
    }, 30);

    setTimeout(function () {
      projectsMasonry.layout();
    }, 220);
  }

  if (typeof imagesLoaded !== 'undefined') {
    imagesLoaded(grid, function () {
      initProjectsMasonry();
    });
  } else {
    initProjectsMasonry();
  }

  document.addEventListener('facetwp-loaded', function () {
    if (typeof imagesLoaded !== 'undefined') {
      imagesLoaded(grid, function () {
        initProjectsMasonry();
        layoutProjectsMasonry();
      });
    } else {
      initProjectsMasonry();
      layoutProjectsMasonry();
    }
  });

  window.addEventListener('resize', function () {
    if (projectsMasonry) {
      projectsMasonry.layout();
    }
  });
});






// Slight projects page parralax
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.projects-grid');
  if (!grid) return;

  function updateProjectParallax() {
    if (window.innerWidth < 992) {
      document.querySelectorAll('.project-inner').forEach(function (el) {
        el.style.transform = '';
      });
      return;
    }

    var gridRect = grid.getBoundingClientRect();
    var gridCenter = gridRect.left + (gridRect.width / 2);

    document.querySelectorAll('.project-card').forEach(function (card) {
      var inner = card.querySelector('.project-inner');
      if (!inner) return;

      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + (rect.width / 2);
      var distanceFromCenter = Math.abs(cardCenter - gridCenter);

      // only affect the center-ish column
      var threshold = rect.width * 0.6;

      if (distanceFromCenter < threshold) {
        var y = window.scrollY * 0.03;
        inner.style.transform = 'translate3d(0, ' + y.toFixed(2) + 'px, 0)';
        inner.style.zIndex = '3';
      } else {
        inner.style.transform = 'translate3d(0, 0, 0)';
        inner.style.zIndex = '1';
      }
    });
  }

  var ticking = false;

  function requestParallaxUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateProjectParallax();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
  window.addEventListener('resize', requestParallaxUpdate);

  setTimeout(requestParallaxUpdate, 100);
});




// Compact slide out menu
jQuery(document).ready(function () {
  var $header = jQuery('header.headroom').first();
  if (!$header.length) return;

  if (!$header.find('.menu-toggle').length) {
    $header.append(
      '<button class="menu-toggle" type="button" aria-expanded="false" aria-label="Toggle navigation">' +
        '<span></span><span></span><span></span>' +
      '</button>'
    );
  }

  var $toggle = $header.find('.menu-toggle');

  $toggle.on('click', function () {
    $header.toggleClass('nav-is-open');
    $toggle.attr('aria-expanded', $header.hasClass('nav-is-open') ? 'true' : 'false');
  });
});








// Reveal shortcode
(function () {
    var duration = 250;

    function slideDown(element) {
        element.hidden = false;
        element.style.display = 'block';
        element.style.height = '0px';
        element.style.overflow = 'hidden';
        element.style.transition = 'height ' + duration + 'ms ease';

        var height = element.scrollHeight;

        requestAnimationFrame(function () {
            element.style.height = height + 'px';
        });

        window.setTimeout(function () {
            element.style.height = 'auto';
            element.style.overflow = '';
            element.style.transition = '';
        }, duration);
    }

    function slideUp(element) {
        element.style.height = element.scrollHeight + 'px';
        element.style.overflow = 'hidden';
        element.style.transition = 'height ' + duration + 'ms ease';

        requestAnimationFrame(function () {
            element.style.height = '0px';
        });

        window.setTimeout(function () {
            element.hidden = true;
            element.style.display = '';
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
        }, duration);
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest('.reveal-shortcode__button');

        if (!button) {
            return;
        }

        var reveal = button.closest('.reveal-shortcode');
        var content = reveal.querySelector('.reveal-shortcode__content');
        var isOpen = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        reveal.classList.toggle('is-open', !isOpen);

        if (isOpen) {
            slideUp(content);
        } else {
            slideDown(content);
        }
    });
})();




// Add header class after user scrolls past 100px
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.header');

  if (!header) {
    return;
  }

  var threshold = 100;
  var ticking = false;

  function updateHeaderScrollClass() {
    if (window.scrollY >= threshold) {
      header.classList.add('header--past-threshold');
    } else {
      header.classList.remove('header--past-threshold');
    }

    ticking = false;
  }

  function requestHeaderScrollUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderScrollClass);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestHeaderScrollUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderScrollUpdate);

  updateHeaderScrollClass();
});



// Parallax image background
window.addEventListener('load', function() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var sections = document.querySelectorAll('.parallax-img-bg');

  for (var i = 0; i < sections.length; i++) {
    initParallaxBg(sections[i], i);
  }

  function initParallaxBg(section, index) {
    var inner = section.querySelector('.inner');
    if (!inner) return;

    var bgImage = section.getAttribute('data-bg');

    if (bgImage) {
      section.style.setProperty('--parallax-bg-image', 'url("' + bgImage + '")');
    }

    var triggerId = 'parallax-bg-' + index;

    function build() {
      var existing = ScrollTrigger.getById(triggerId);

      if (existing) {
        existing.kill();
      }

      var moveAmount = 60;
      var baseOffset = -20;

      section.style.setProperty('--bg-parallax-y', (baseOffset + moveAmount) + 'px');

      ScrollTrigger.create({
        id: triggerId,
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        // markers: true,

        onUpdate: function(self) {
          var y = baseOffset + moveAmount - (moveAmount * 2 * self.progress);
          section.style.setProperty('--bg-parallax-y', y + 'px');
        },

        onLeaveBack: function() {
          section.style.setProperty('--bg-parallax-y', (baseOffset + moveAmount) + 'px');
        }
      });
    }

    build();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        build();
        ScrollTrigger.refresh();
      }, 150);
    });
  }

  ScrollTrigger.refresh();
});


jQuery(document).ready(function () {
  console.log('starting gallery');
  jQuery(function ($) {
    $('section[data-featherlight-gallery]').featherlightGallery({
      filter: 'a.gallery',
      previousIcon: '‹',
      nextIcon: '›'
    });
  });
});
